import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { getCountries } from '@services/apis/insure/term';
import { COUNTRY_INDIA } from '@utils/constants';

interface CountryStore {
  countries: any[];
  isLoading: boolean;
  fetchCountries: () => Promise<void>;
}

export const useCountryStore = create<CountryStore>()(
  persist(
    (set, get) => ({
      countries: [COUNTRY_INDIA],
      isLoading: false,
      fetchCountries: async () => {
        const { isLoading, countries } = get();
        if (countries?.length > 1 || isLoading) {
          return;
        }

        try {
          set({ isLoading: true });
          const response = await getCountries();
          if (!response?.success) {
            set({
              isLoading: false
            });
          }
          set({ countries: response.data, isLoading: false });
        } catch (error) {
          set({ isLoading: false });
        }
      }
    }),
    {
      name: 'country-storage'
    }
  )
);
